import type { ReactNode } from "react";

export type Status = "ready" | "pending" | "empty" | "error";
export type Variant = "neutral" | "info" | "success" | "warning" | "danger";
export type Size = "sm" | "md";

export function StatusBadge({
  label,
  status,
  variant,
  size = "sm",
  icon,
}: {
  label: string;
  status?: Status;
  variant?: Variant;
  size?: Size;
  icon?: ReactNode;
}) {
  const height = size === "md" ? "h-2.5 w-2.5" : "h-2 w-2";
  const pad = size === "md" ? "px-2.5 py-1.5 text-[11px]" : "px-2 py-1 text-xs";
  let dot = "bg-muted";
  if (status) {
    if (status === "ready") dot = "bg-success";
    else if (status === "pending") dot = "bg-warning animate-pulse";
    else if (status === "error") dot = "bg-danger";
    else dot = "bg-muted";
  } else if (variant) {
    dot = variant === "success" ? "bg-success" : variant === "warning" ? "bg-warning" : variant === "danger" ? "bg-danger" : variant === "info" ? "bg-ring" : "bg-muted";
  }
  return (
    <span className={`inline-flex items-center gap-2 rounded-full border bg-surface ${pad} text-text`}>
      {icon ? <span className="text-current">{icon}</span> : <span className={`rounded-full ${height} ${dot}`} />}
      {label}
    </span>
  );
}
